export default "__VITE_ASSET__95q_yfk2__"